export enum AnalyteType {
	STIMULANT = "Stimulant",
	OTHER_SUBSTANCE = "Other substance",
}

export enum AnalyteStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DELETED = "DELETED",
}

export interface IAnalyte {
	_id: string;
	accountId: string;
	shortname: string;
	shortnameDisplay: string;
	scientificName: string;
	scientificDisplay: string;
	type: AnalyteType;
	status: AnalyteStatus;
	isDeleted: boolean;
	createdBy: string;
	updatedBy?: string;
	createdAt: Date;
	updatedAt: Date;
}

export interface AnalytesResponse {
	statusCode: number;
	body: IAnalyte[];
}

export interface AnalytesPaginatedResponse {
	statusCode: number;
	body: {
		data: IAnalyte[];
		pagination: {
			currentPage: number;
			pageSize: number;
			totalCount: number;
			totalPages: number;
		};
	};
}
